import Swiper from "swiper/bundle";

const [ w, d, mq ] = [window, document, window.matchMedia( "(max-width: 900px)" ) ];
const domReady = () => {
  new eventBLOCKS;
};

class eventBLOCKS {
  constructor() {
    this.MainImg();
  }
  
  MainImg () {
    const thumbSlider = new Swiper('.p-ed__thumb-slider', {
      slidesPerView: 6,
    });

    const mainSlider = new Swiper('.p-ed__main-slider', {
      grabCursor: true,
      speed: 400,
      slidesPerView: 1,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      thumbs: {
        swiper: thumbSlider,
      },
    });
  }
}

export default function EVENT () {
  w.addEventListener('load', domReady);
}